import { ApiModuleType, UserModuleType } from "../@types/api";
const api: ApiModuleType & UserModuleType = {
  login: {
    url: "/user/login",
    method: "post",
  },
  sendVerifyCode: {
    url: "/user/sendCode",
    method: "post",
  },
  register: {
    url: "/user/register",
    method: "post",
  },
  getInfo: {
    url: "/user/info",
    method: "get",
  },
  updateAvatar: {
    url: "/user/avatar",
    method: "put",
  },
  updateInfo: {
    url: "/user/info",
    method: "put",
  },
  updatePassword: {
    url: "/user/password",
    method: "put",
  },
}
export default api;